import ComHero from '@tencent/tpm-meeting/lib/ComHero';
import '@tencent/tpm-meeting/lib/ComHero/style';
import React from 'react';
import VersionSelect from '../VersionSelect';
import styles from './index.module.scss';
import { IProduct } from '@/tpss/types';
import { numToStr } from '@/tpss/utils/utils';

interface ProductDetailHeroProps {
  productVersionRaw: any;
  productDetail: IProduct;
  activeVersionId: string;
  activeProductCode: string;
  onVersionChange: (version: { id: string; name: string }) => void;
  onProductCodeChange: (productCode: { id: string; name: string }) => void;
}

const ProductDetailsBanner: React.FC<ProductDetailHeroProps> = ({
  productVersionRaw,
  productDetail,
  activeVersionId,
  onVersionChange
}) => {
  // const { currentProductVersion } = useContext(ProductDetailContext);

  // const [versionData, setVersionData] = useState<{ id: string; name: string }>({
  //   id: '',
  //   name: ''
  // });

  // const [versionData, setVersionData] = useState<{ id: string; name: string }>({
  //   id: '',
  //   name: ''
  // });

  const onVersionSelectChange = (version: { id: string; name: string }) => {
    onVersionChange(version);
    // setVersionData(version);
  };

  // const onProductCodeSelectChange = (productCode: { id: string; name: string }) => {
  //   onProductCodeChange(productCode);
  //   // setVersionData(version);
  // };

  function getProductVersionOptions() {
    const versionOptions = productVersionRaw?.map((version) => ({
      key: numToStr(version.ID),
      value: numToStr(version.ID),
      label: version.ProductVersionName
    }));
    // console.log('versionOptions', versionOptions);
    return versionOptions;
  }

  // function getProductCodeOptions() {
  //   const productCodeSet = new Set<string>();
  //   if (productDetail.ProductPatchMode === ProductPatchModeStandalone) {
  //     return [];
  //   }
  //   if (!productDetail.Versions) {
  //     return [];
  //   }
  //   for (const version of productDetail.Versions) {
  //     if (!version.Nodes) {
  //       continue;
  //     }
  //     for (const baselineNode of version.Nodes) {
  //       if (!baselineNode.Nodes) {
  //         continue;
  //       }
  //       for (const patch of baselineNode.Nodes) {
  //         productCodeSet.add(patch.ProductCode);
  //       }
  //     }
  //   }
  //   const productCodeOptions: IOption[] = [];
  //   productCodeSet.forEach((productCode) => {
  //     productCodeOptions.push({
  //       value: productCode,
  //       label: productCode
  //     });
  //   });
  //   console.log('productCodeOptions', productCodeOptions);

  //   return productCodeOptions;
  // }

  // function getProductCodeSelectVisible() {
  //   return productDetail.ProductPatchMode === ProductPatchModeMix;
  // }

  return (
    <ComHero
      className={styles.heroWrapper}
      v2
      title={productDetail?.ProductName}
      desc={productDetail?.ProductDescription}
      bgColor="#F8F9FC"
      bgRender={
        <div className={styles.bannerContainer}>
          <div className={styles.bg}></div>
          <div className={styles.maskContainer}>
            <div className={styles.rightMask}></div>
            <div className={styles.leftMask}></div>
          </div>
        </div>
      }
      btns={[
        {
          render: (
            <VersionSelect
              visible={true}
              title="产品版本"
              activeId={activeVersionId}
              options={getProductVersionOptions()}
              onChange={onVersionSelectChange}
            />
          )
        }
      ]}
    ></ComHero>
  );
};

export default ProductDetailsBanner;
